/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import authProfileState from "../../states/authProfileState";
import { useRecoilValue } from "recoil";
import getSchema from "../../lib/api/getSchema";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import { CellType } from "@grapecity/wijmo.grid";
import AccessControl from "../functional/AccessControl";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import SaveToExcelButton from "../input/SaveToExcelButton";
import MomSysBackShipButton from "../input/MomSysBackShipButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import ApprovalButton from "../input/ApprovalButton";
import MomSysBackShipDetail from "./MomSysBackShipDetail";
import { debounce, cloneDeep } from "lodash";
import defineConf from "../../config/defineConf";
import MomSysBackShipTransactionButton from "../input/MomSysBackShipTransactionButton";

function MomSysBackShip(props) {
    const id = "MomSysBackShip";
    const table = "MomSysBackShip";
    const view = "MomSysVwBackShip";

    const [height, setHeight] = useState(0);

    const [momSysBackShipSchema, setMomSysBackShipSchema] = useState();
    const [modifiedUpdateSchema, setModifiedUpdateSchema] = useState();

    const [momSysBackShipGrid, setMomSysBackShipGrid] = useState();
    const [momSysBackShipApi, setMomSysBackShipApi] = useState();
    const [momSysBackShipData, setMomSysBackShipData] = useState();
    const [momSysBackShipDataIsEmpty, setMomSysBackShipDataIsEmpty] = useState();
    const [momSysBackShipDetailDataIsEmpty, setMomSysBackShipDetailDataIsEmpty] = useState();
    const [momSysBackShipSelect, setMomSysBackShipSelect] = useState();

    const authProfile = useRecoilValue(authProfileState);

    const { t } = useTranslation();

    const [approvalCtx, setApprovalCtx] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();

        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setMomSysBackShipSchema(schema);
            }
        })();

        return () => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const modifiedSchema = cloneDeep(momSysBackShipSchema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "dueDate":
                    case "deliveryState":
                        column.hideInForm = true;
                        break;

                    default:
                        break;
                }
            }

            setModifiedUpdateSchema(modifiedSchema);
        }
    }, [momSysBackShipSchema]);

    useEffect(() => {
        let approvalCtx = {
            approvalTypeId: 17,
            tableName: table,
            statusColumn: "approvalStateId",
            schema: setMomSysBackShipSchema,
            onValidateApprovalItem: (item) => {
                if (item.createdBy !== authProfile.username) {
                    return [false, t("error.approvalRequesterNotMatch")];
                }

                return [true, ""];
            },
            makeRequestItemDescription: (item) => {
                return `${t("approvalRequestMsg.msg.momSysBackShip", {
                    orderBuyerId: item.orderBuyerId,
                    orderBuyerName: item.orderBuyerName,
                })}`; // Use Translation on Production Code
            },
        };

        setApprovalCtx(approvalCtx);
    }, [setMomSysBackShipSchema]);

    useEffect(() => {
        (async () => {
            if (momSysBackShipGrid) {
                momSysBackShipGrid.selectionChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setMomSysBackShipSelect(grid.selectedItems[0]);
                        } else {
                            setMomSysBackShipSelect([]);
                        }
                    },10)
                );

                momSysBackShipGrid.itemsSourceChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setMomSysBackShipSelect(grid.selectedItems[0]);
                        } else {
                            setMomSysBackShipSelect([]);
                        }
                    },10)
                );
            }
        })();
    }, [momSysBackShipGrid]);

    const exportFormatItem = (args) => {
        let { panel, col, row, xlsxCell } = args;

        if (momSysBackShipData && panel.cellType === CellType.Cell) {
            switch (panel.columns[col].binding) {
                case "approvalState":
                    switch (momSysBackShipData[row][panel.columns[col].binding]) {
                        case defineConf.approvalState.PENDING:
                            xlsxCell.value = t("selectItems.approvalState.approvalPending");

                            break;

                        case defineConf.approvalState.PARTIALLY_APPROVED:
                            xlsxCell.value = t("selectItems.approvalState.partiallyApproved");

                            break;

                        case defineConf.approvalState.APPROVED:
                            xlsxCell.value = t("selectItems.approvalState.totallyApproved");

                            break;

                        case defineConf.approvalState.REJECTED:
                            xlsxCell.value = t("selectItems.approvalState.approvalRejected");

                            break;

                        case defineConf.approvalState.WITHDRAWN:
                            xlsxCell.value = t("selectItems.approvalState.approvalWithdrawn");

                            break;

                        case defineConf.approvalState.CANCELLED:
                            xlsxCell.value = t("selectItems.approvalState.approvalCancelled");

                            break;

                        default:
                            break;
                    }

                    break;

                default:
                    break;
            }
        }
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.6} data-cy="Master">
                    <BasicCrudScreenType
                        id={id}
                        headerTitle={t("term.backShip")}
                        table={table}
                        view={view}
                        onInitialized={(grid) => {
                            setMomSysBackShipGrid(grid);
                        }}
                        onApiInitialized={(api) => {
                            setMomSysBackShipApi(api);
                        }}
                        onLoadData={(data) => {
                            setMomSysBackShipData(data);
                            setMomSysBackShipDataIsEmpty(data.length < 1 ? true : false);
                        }}
                        exportFormatItem={exportFormatItem}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onAppendButtonInFrontOfSearch={() => (
                            <BasicCrudScreenActionItemLayout>
                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod="POST"
                                >
                                    <MomSysBackShipButton
                                        id={id}
                                        schema={momSysBackShipSchema}
                                        refresh={momSysBackShipApi}
                                        onSuccess={onSuccess}
                                    />
                                </AccessControl>

                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod={
                                        momSysBackShipSchema && (momSysBackShipSchema.updateWithPatch ? "PATCH" : "PUT")
                                    }
                                >
                                    <UpdateRecordButton
                                        id={id}
                                        schema={modifiedUpdateSchema}
                                        grid={momSysBackShipGrid}
                                        refresh={momSysBackShipApi}
                                        disabled={momSysBackShipSelect?.approvalState || momSysBackShipDataIsEmpty}
                                        onSuccess={onSuccess}
                                    />
                                </AccessControl>

                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod="DELETE"
                                >
                                    <DeleteRecordButton
                                        id={id}
                                        schema={momSysBackShipSchema}
                                        grid={momSysBackShipGrid}
                                        refresh={momSysBackShipApi}
                                        color="secondary"
                                        disabled={
                                            momSysBackShipSelect?.approvalState ||
                                            momSysBackShipDataIsEmpty ||
                                            !momSysBackShipDetailDataIsEmpty
                                        }
                                        onSuccess={onSuccess}
                                        onFailure={onFailure}
                                        onPartialFailure={onNotifyWarning}
                                    />
                                </AccessControl>

                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod="POST"
                                >
                                    <MomSysBackShipTransactionButton
                                        id={id}
                                        refresh={momSysBackShipApi}
                                        onSelectMst={momSysBackShipSelect}
                                        disabled={momSysBackShipDataIsEmpty || momSysBackShipDetailDataIsEmpty || momSysBackShipSelect?.backShipStatus === defineConf.backShipStatus.COMPLETED}
                                        onSuccess={onSuccess}
                                        onFailure={onFailure}
                                    />
                                </AccessControl>

                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod="APPROVAL"
                                >
                                    <ApprovalButton
                                        id={id}
                                        grid={momSysBackShipGrid}
                                        refresh={momSysBackShipApi}
                                        approvalCtx={approvalCtx}
                                        disabled={momSysBackShipDataIsEmpty || momSysBackShipDetailDataIsEmpty}
                                        onSuccess={onSuccess}
                                        onFailure={onFailure}
                                    />
                                </AccessControl>

                                <AccessControl
                                    accessTarget={momSysBackShipSchema && momSysBackShipSchema.name}
                                    accessMethod="SAVETOEXCEL"
                                >
                                    <SaveToExcelButton
                                        id={id}
                                        grid={momSysBackShipGrid}
                                        view={view}
                                        color="primary"
                                        exportFormatItem={exportFormatItem}
                                        disabled={momSysBackShipDataIsEmpty}
                                    />
                                </AccessControl>
                            </BasicCrudScreenActionItemLayout>
                        )}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement flex={0.4} data-cy="Detail">
                    {momSysBackShipSelect ? (
                        <MomSysBackShipDetail
                            id="MomSysBackShipDetail"
                            onSelectMst={momSysBackShipSelect}
                            onDetailEmpty={(isEmpty) => {
                                setMomSysBackShipDetailDataIsEmpty(isEmpty);
                            }}
                        />
                    ) : (
                        <></>
                    )}
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default MomSysBackShip;
